import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import courseData from '../../data/courseData';
import CourseCard from '../../layouts/CourseCard';

const Courses = () => {
  const [filter, setFilter] = useState("BBA");

  // Filter courses and limit to 3
  const filteredCourses = courseData
    .filter((course) => course.type.toLowerCase() === filter.toLowerCase())
    .slice(0, 3);

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        when: "beforeChildren"
      }
    }
  };

  const itemVariants = {
    hidden: { 
      opacity: 0,
      y: 20 
    },
    visible: { 
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <div className=" mx-auto px-4 py-8">
      <div className="text-center mb-8 sm:mb-12">
        <h1 className="text-3xl sm:text-4xl font-medium text-gray-900 mb-4">
          Our Courses
        </h1>
        <p className="text-gray-600 max-w-2xl mx-auto">
          Discover our comprehensive range of aviation programs designed to launch your career in the aviation industry
        </p>
      </div>

      <div className="flex gap-4 justify-center mb-12">
        <button
          onClick={() => setFilter("BBA")}
          className={`px-6 py-2.5 text-sm rounded-full transition-all duration-300 ${
            filter === "BBA" 
              ? "bg-red-600 text-white shadow-lg" 
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
          BBA
        </button>
        <button
          onClick={() => setFilter("MBA")}
          className={`px-6 py-2.5 text-sm rounded-full transition-all duration-300 ${
            filter === "MBA" 
              ? "bg-red-600 text-white shadow-lg" 
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
          MBA
        </button>
        <button
          onClick={() => setFilter("Diploma")}
          className={`px-6 py-2.5 text-sm rounded-full transition-all duration-300 ${
            filter === "Diploma" 
              ? "bg-red-600 text-white shadow-lg" 
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
          Diploma
        </button>
      </div>

      <motion.div 
        // className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 mx-3 md:mx-10 lg:mx-20"
        className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 max-w-6xl mx-auto"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        key={filter} // Add key to force re-render on filter change
      >
        {filteredCourses.map((course) => (
          <motion.div
            key={course.id}
            variants={itemVariants}
            layout // Add layout prop for smooth transitions
          >
            <CourseCard course={course} />
          </motion.div>
        ))}
      </motion.div>

      <div className="text-center mt-12">
        <Link 
          to={`/courses?category=${filter}`}
          className="inline-flex items-center gap-2 px-5 sm:px-8 py-2 sm:py-3 bg-red-600 text-white rounded-full 
                     font-medium shadow-lg hover:bg-red-700 transition-all duration-300 
                     transform hover:-translate-y-0.5"
        >
          View All {filter} Courses
          <svg 
            className="w-5 h-5" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M17 8l4 4m0 0l-4 4m4-4H3" 
            />
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default Courses;
